import React from 'react';

const OrganizingCommittee = () => {
  const committee = [
    {
      title: "Chief Patron",
      members: ["Dr. Rajeev Tiwari, IILM University, Greater Noida"],
    },
    {
      title: "General Chairs",
      members: [
        "Dr. Harshal Patil, IILM University, Greater Noida",
        "Dr. Jasminder Kaur Sandhu, IILM University, Greater Noida",
      ],
    },
    {
      title: "Program and Organizing Chairs",
      members: ["Dr. Lalit Kumar, IILM University, Greater Noida"],
    },
    {
      title: "Conveners",
      members: [
        "Dr. Lalit Kumar, IILM University, Greater Noida",
        "Dr. Deependra Rastogi, IILM University, Greater Noida, India",
      ],
    },
    {
      title: "Organizing Secretary",
      members: ["Dr. Sumit Singh Dhanda", "Suman Avdhesh Yadav", "Shantanu Bindewari"],
    },
    {
      title: "Technical Chairs",
      members: [
        "Prof. Brahmjit Singh, NIT Kurukshetra",
        "Dr. Smita Sharma, National Institute of Electronics & Information Technology (NIELIT), India",
        "Dr. Poonam Jindal, NIT Kurukshetra",
        "Dr. Vijander Singh, NTNU, Alesund",
        "Dr. Smita Nirkhi, GH Raisoni College of Engineering and Management Nagpur, India",
        "Dr. Sanyog Rawat, Central University Rajasthan",
        "Dr. Deepak Panwar, Manipal University Jaipur, Rajasthan",
        "Dr. R C Poonia, CHRIST (Deemed to be University), Bengaluru",
        "Dr. Kamal Kant Verma, IILM University, Greater Noida",
      ],
    },
    {
      title: "Technical Program Committee",
      members: [
        "Prof. Pardeep Singh, Galgotias University, Uttar Pradesh",
        "Dr. Sunil Nain, UIET, Kurukshetra University, Kurukshetra",
        "Dr. Sandeep Punia, CHRIST (Deemed to be University), Bengaluru",
        "Prof. (Dr.) Rajiv Agarwal, Senior, LIET Greater Noida, India",
        "Dr. Sandeep Verma, NIT Jalandhar, India",
        "Dr. Sourabh Jain, IIIT Sonepat, India",
        "Dr. Vandana Sharma, Christ University Delhi NCR, India",
        "Prof. (Dr.) Brijmohan Singh, Quantum University, India",
        "Prof. Balamurugan Balusamy, Shiv Nadar University, India",
        "Dr. Shashikant Patil, Atlas SkillTech University Mumbai, India",
        "Dr. Abhimanyu Nain, Guru Jambheshwar University, Hisar, Haryana",
        "Dr. Ajay Punia, Guru Jambheshwar University, Hisar, Haryana",
        "Prof. Sanjay Jain, Amity University Rajasthan, Jaipur",
        "Prof. Ashwani Yadav, Amity University Rajasthan",
        "Dr. Amit Kumar, Galgotias University, Greater Noida",
        "Dr. Jitendra Rajpurohit, Symbiosis University, Pune",
        "Dr. Pankaj Agarwal, Jindal Steels Ltd.",
        "Prof. Sanjay Yadav, Alliance University, Bengaluru",
      ],
    },
    {
      title: "Industrial and Entrepreneur Chairs",
      members: ["Mr. Vaibhav Sharma, IILM University, Greater Noida, India"],
    },
    {
      title: "Finance Committee",
      members: [
        "Mr. Abhinav Raghav, IILM University, Greater Noida, India",
        "Mr. Vikas Tiwari, IILM University, Greater Noida, India",
      ],
    },
    {
      title: "Registration Committee",
      members: [
        "Dr. Anand Singh, IILM University, Greater Noida, India",
        "Ms. Apoorva Jain, IILM University, Greater Noida, India",
      ],
    },
    {
      title: "Web Administrators",
      members: ["Mr. Shantanu Bindewari, IILM University, Greater Noida"],
    },
    {
      title: "Women@Tech4SDG",
      members: [
        "Dr. Kirti Shukla, IILM University, Greater Noida, India",
        "Dr. Apoorva Jain, IILM University, Greater Noida, India",
        "Ms. Heena Khera, IILM University, Greater Noida, India",
        "Ms. Reeta Mishra, IILM University, Greater Noida, India",
        "Dr. Divya Prakash, Shobhit University Gangoh",
        "Dr. Pushpa Singh, IILM University, Greater Noida, India",
        "Dr. Preeti Narooka, Manipal University Jaipur, Rajasthan",
        "Dr. Daksha Baroda, IILM University, Greater Noida, India",
      ],
    },
  ];

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold text-center mb-6">Organizing Committee</h1>
      {committee.map((section, index) => (
        <div key={index} className={`mb-6 ${index === 0 ? 'mt-4' : ''}`}>
          <h2 className="text-xl font-semibold mb-2">{section.title}</h2>
          <ul className="list-disc pl-6">
            {section.members.map((member, idx) => (
              <li key={idx} className="mb-1">{member}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default OrganizingCommittee;
